import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { SmartCreatePageEditorLoader } from '@confluence/smart-create-page-editor';
import { fg } from '@confluence/feature-gating';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { HOME } from '@confluence/named-routes/entry-points/routes.ts';
import { ClassicEditorContextProviderLoader } from '@confluence-classic/confluence-fabric-editor/src/components/ClassicEditorContextProvider/index.js';

import { navdexEnd } from '../naxdev.js';

export const EditPageSmartCreateRoute = ({
	params: { contentId },
	query: { sharedFeaturesInstrumentationId },
}: RouteMatch) => {
	if (!fg('aifc_create_enabled')) {
		return <Redirection href={HOME.toUrl()} />;
	}

	return (
		<ClassicEditorContextProviderLoader>
			<SmartCreatePageEditorLoader
				contentId={contentId}
				sharedFeaturesInstrumentationId={sharedFeaturesInstrumentationId as string}
			/>
		</ClassicEditorContextProviderLoader>
	);
};

EditPageSmartCreateRoute.NAVIGATION_PARAMS = ({ params: { contentId, spaceKey } }: RouteMatch) => ({
	Screen: {
		showPremiumOnboarding: false,
		screenEvent: {
			name: 'editPageSmartCreateScreen',
			id: contentId,
			...navdexEnd,
		},
		pageState: { contentId, spaceKey, contentType: 'page' },
	},
	MainLayout: false,
	BannerContext: { includeTopNav: false },
});
